import { _ } from '_core';

import { Params } from './types';

export const validate = (params: Params) => {
  if (_.isEmpty(params.return_horizons)) return ['Return horizon is required field.'];
  return [];
};
